<template>
    <div>
        <el-card class="box-card">
            <div class="text item">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form :inline="true" class="demo-form-inline" size="small"
                                style="text-align: left;margin-top:5px;height:30px" ref="Searchform" :model="Search">
                                <el-form-item label="用户昵称" prop="dynamic_title">
                                    <el-input v-model="Search.jp_nick_name" placeholder="请输入用户昵称" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="手机号" prop="dynamic_title">
                                    <el-input v-model="Search.jp_phone" placeholder="请输入用户手机号码" clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button icon="el-icon-search" type="primary" size="mini"
                                        @click="getCampusUserList()">查询</el-button>
                                    <el-button icon="el-icon-refresh" size="mini" @click="ClearSearchform()">重置</el-button>
                                </el-form-item>
                                <!-- </el-col> -->
                                <!-- </el-row> -->
                            </el-form>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple-light">
                            <el-table 
                                :data="tableData_campus_user" 
                                border 
                                style="width: 100%"
                                max-height="600"
                                :default-sort="{ prop: 'createTime', order: 'descending' }">
                                <el-table-column prop="jpPortrait" label="用户头像" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-avatar :size="40" :src="scope.row.jpPortrait" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="jpNickName" label="用户昵称" min-width="120" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="jpPhone" label="手机号码" width="130">
                                </el-table-column>
                                <el-table-column prop="createTime" label="注册时间" width="180" sortable>
                                    <template slot-scope="scope">
                                        <i class="el-icon-time"></i>
                                        <span style="margin-left: 10px">{{ scope.row.createTime | dateFormat }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="jpRole" label="用户权限" width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.jpRole == '0'" type="info" size="small">普通用户</el-tag>
                                        <el-tag v-if="scope.row.jpRole == '2'" size="small">兼职</el-tag>
                                        <el-tag v-if="scope.row.jpRole == '1'" type="warning" size="small">负责人</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="jpStatus" label="用户状态" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.jpStatus" active-color="#13ce66" inactive-color="#ff4949" active-value="0"
                        inactive-value="1" @change="SwitchChange(scope.row)"></el-switch>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-search" size="mini"
                                            @click="toUpdate(scope.row)">修改</el-button>
                                        <el-button type="danger" icon="el-icon-delete" size="mini"
                                            @click="toDelete(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :span="24">
                        <div style="text-align: center;">
                            <el-pagination 
                                v-if="tableData_campus_user.length != 0"
                                background 
                                layout="total, prev, pager, next, jumper" 
                                :total="total" 
                                :current-page="queryObj.page"
                                :page-size="queryObj.limit"
                                @size-change="handleSizeChange" 
                                @current-change="handleSizeChange">
                            </el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        <!-- 修改对话框 -->
        <el-dialog title="修 改" :visible.sync="Update_dialog" width="20%" :before-close="handleClose" center>
            <el-form ref="updateform" :model="Updateform" :rules="rules" label-width="80px">
                    <div style="display:flex;justify-content:center;margin:20px 0;">
                            <el-image
              style="width: 120px; height: 120px"
              :src="Updateform.jpPortrait"
              ></el-image>
                        </div>
                    <el-form-item label="用户昵称" prop="jpNickName" :rules="rules">
                        <el-input v-model="Updateform.jpNickName"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="jpPhone" :rules="rules">
                        <el-input v-model="Updateform.jpPhone"></el-input>
                    </el-form-item>
            </el-form>
            <!-- <span>这是一段信息</span> -->
            <span slot="footer" class="dialog-footer">
                <el-button icon="el-icon-close" type="danger" @click="Update_dialog = false">取 消</el-button>
                <el-button icon="el-icon-check" type="success" @click="UpdateCampusUser()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            //验证规则
            rules:
                [
                    { required: true, message: "请输入内容", trigger: 'blur' },
                    { pattern: !/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi, message: "请输入合法字符", trigger: "blur" }
                ]
            ,
            Search: {//搜索内容
                jp_nick_name: '',
                jp_phone: '',
            },
            total: 0,//分页总条目
            tableData_campus_user: [],//表格数据(小程序普通用户)
            loading: false,//搜索加载
            queryObj: {//分页渲染条件
                limit: 8,//行
                page: 1,//页数
                query: "",//条件
            },
            Updateform:{},//修改用户
            Update_dialog:false,//修改对话框
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 启用禁用
        async SwitchChange(Data){
            this.Updateform = Data
            const { data: res } = await this.$http.post('campususer/updateCampusUser', this.Updateform);
            if (res.code == 200 && Data.jpStatus==1) {
                this.$message({ type: "success", message: "已禁用！" })
                this.getCampusUserList()
            }else if(res.code == 200 && Data.jpStatus==0){
                this.$message({ type: "success", message: "已启用！" })
                this.getCampusUserList()
            } 
            else {
                this.$message({ type: "error", message: "修改失败！" })
                this.getCampusUserList()
            }
        },
        // 修改用户信息
        async UpdateCampusUser() {
            const { data: res } = await this.$http.post('campususer/updateCampusUser', this.Updateform);
            if (res.code == 200) {
                this.$message({ type: "success", message: "修改成功！" })
                this.getCampusUserList()
            } else {
                this.$message({ type: "error", message: "修改失败！" })
                this.getCampusUserList()
            }
            this.Update_dialog=false
        },
        // 点击修改
        toUpdate(Data) {
            this.Updateform = Data
            this.Update_dialog = true
        },
        // 点击删除
        toDelete(Data) {
            this.$confirm('确定删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.delete('campususer/delCampusUser', {
                    params: {
                        id: Data.id,
                    }
                });
                if (res.code == 200) {
                    this.$message({ type: "success", message: "删除成功!" })
                    this.getSchoolList()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        //分页交互调用事件
        handleSizeChange(newPage) {
            this.queryObj.page = newPage;
            this.getCampusUserList();
        },
        // 拼接字符串条件
        Query(Str) {
            for (var key in Str) {
                if (Str[key] == '' || Str[key] == null) {
                    delete Str[key]
                }
            }
            let str = JSON.stringify(Str).replace(/(\{")/g, "").replace(/(\":)/g, ' like ').replace(/}/g, '').replace(/,"/g, ' and ').replace(/{/g, '').replace(/"/g, '%"').replace('like %"', 'like "%');
            return str
        },
        // 重置搜索表单
        ClearSearchform() {
            console.log("重置搜索表单");
            this.$refs.Searchform.resetFields()
        },
// 对话框关闭
handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        // 重新渲染表格
        // 渲染表格数据(动态)数据
        async getCampusUserList() {
            let str = this.Query(this.Search);
            console.log(str.length);
            console.log(str);
            this.queryObj.query = str
            const { data: res } = await this.$http.get('/campususer/getCampusUserList',
                {
                    params: this.queryObj
                });
            console.log(res)
            this.tableData_campus_user = res.data.children;
            this.total = res.data.total;
        },
    },
    created() {

    },
    mounted() {
        this.getCampusUserList()
    }
};
</script>

<style scoped>
.box-card {
    width: 100%;
}

.item {
    margin-bottom: 18px;
}

.grid-content {
    margin: 20px 0;
}


</style>